import http from "../../http";

/** 催缴通知 — /resident/api/resident/houseBillNotify */
const BASE = "/resident/api/resident/houseBillNotify";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  itemPage(r) {
    return http.get(`${BASE}/itemPage`, r);
  },
  /** 欠费户预览（透视勾选） */
  preview(r) {
    return http.get(`${BASE}/preview`, r);
  },
  create(r) {
    return http.payload(`${BASE}/create`, r);
  },
};
